import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import { SharedModule } from 'primeng/api';

/**
 * InputGroup displays text, icon, buttons and other content can be grouped next to an input.
 * @group Components
 */
const _c0 = ["*"];
let InputGroup = /*#__PURE__*/(() => {
  class InputGroup {
    /**
     * Inline style of the element.
     * @group Props
     */
    style;
    /**
     * Class of the element.
     * @group Props
     */
    styleClass;
    static ɵfac = function InputGroup_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InputGroup)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: InputGroup,
      selectors: [["p-inputGroup"]],
      hostAttrs: [1, "p-element", "p-inputgroup"],
      inputs: {
        style: "style",
        styleClass: "styleClass"
      },
      ngContentSelectors: _c0,
      decls: 2,
      vars: 3,
      consts: [[1, "p-inputgroup", 3, "ngClass", "ngStyle"]],
      template: function InputGroup_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", ctx.styleClass)("ngStyle", ctx.style);
          i0.ɵɵattribute("data-pc-name", "inputgroup");
        }
      },
      dependencies: [i1.NgClass, i1.NgStyle],
      encapsulation: 2
    });
  }
  return InputGroup;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputGroupModule = /*#__PURE__*/(() => {
  class InputGroupModule {
    static ɵfac = function InputGroupModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InputGroupModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: InputGroupModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, SharedModule]
    });
  }
  return InputGroupModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { InputGroup, InputGroupModule };
